'use client';

import { AppProgressBar as ProgressBar } from 'next-nprogress-bar';
import React from 'react';

export default function Provider({ children }: { children: any }) {
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => setMounted(true), []);

  if (!mounted) return null;

  return (
    <>
      {children}
      <ProgressBar
        height='3px'
        color='#FF0000'
        options={{ showSpinner: false }}
        shallowRouting
      />
    </>
  );
}
